<template>
    <div>
        <el-button @click="batchAuditPass" type="primary" v-if="activeTab=='1'">一键审核通过</el-button>
        <el-table :data="auditList" ref="multipleTable" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55" v-if="activeTab=='1'"></el-table-column>
            <el-table-column min-width="60" label="时间">
                <template slot-scope="scope">
                    {{scope.row.createdTime | moment}}
                </template>
            </el-table-column>
            <el-table-column label="账号">
                <template slot-scope="scope">
                    <div class="copystyle">
                        <a class="account-link" @click="getUserDetail(scope.row.userId)">{{scope.row.userId}}</a>
                        <img width="18px" @click="getcopy(scope.row.userId)" src="../../../../../assets/images/copy.png"/>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="风控提示">
                <template  slot-scope="scope">
                    <div v-if="scope.row.riskFlag">
                        <span style="color:red" v-if="scope.row.riskFlag.blockAccountFlag == 1">账户冻结&nbsp;&nbsp;</span>
                        <span style="color:red" v-if="scope.row.riskFlag.forbidOutGoldFlag == 1">禁止提现</span>
                        <span v-if='scope.row.riskFlag.riskFlag ==false'>--</span> 
                    </div>
                    <span v-else>--</span>
                </template>
            </el-table-column>
            <el-table-column label="标签" v-if="showTag">
                <template slot-scope="scope"><span style="color: red">{{scope.row.tags}}</span></template>
            </el-table-column>
            <el-table-column prop="txCoin" label="币种"></el-table-column>
            <el-table-column prop="txAmount" label="提现数量">
                <template slot-scope="scope">
                    <span>{{scope.row.txAmount | toThousands}}</span>
                </template>
            </el-table-column>
            <el-table-column label="提现地址" min-width="150">
                <template slot-scope="scope">
                    <a :href="scope.row.txNetworkLink" target="_blank" class="network-link">{{scope.row.txToAddress}}</a>
                </template>
            </el-table-column>
            <el-table-column label="提现memo" min-width="150">
                <template slot-scope="scope">
                    <a :href="scope.row.txNetworkLink" target="_blank" class="network-link">{{scope.row.txToMemo}}</a>
                </template>
            </el-table-column>
            <el-table-column label="hash">
                <template slot-scope="scope">
                    <a :href="scope.row.txHash" target="_blank" class="network-link">{{scope.row.txHash}}</a>
                </template>
            </el-table-column>
            <el-table-column prop="txStatus" label="状态">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.__status.color" v-if="scope.row.status !== 2">{{scope.row.__status.text}}
                    </el-tag>
                    <span v-if="scope.row.status === 2" class="text-disabled">{{scope.row__status.text}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="txStatusInner" label="内部状态"></el-table-column>
            <el-table-column prop="allDepositEnsured" label="充值确认"  :filters="[{text: '都已确认', value: true}, {text: '有未确认或异常', value: false}]"
                             :filter-method="filterHandler">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.__allDepositEnsured.color">{{scope.row.__allDepositEnsured.text}}</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="remark" show-overflow-tooltip label="备注"></el-table-column>
            <el-table-column key="name1" show-overflow-tooltip label="过审类型">
                <template slot-scope="scope">
                    {{scope.row.approvalType == 0?'人工':scope.row.approvalType == 1?'系统小额过审':'--'}}
                </template>
            </el-table-column>
            <el-table-column prop="extraInfo" show-overflow-tooltip label="其他信息"></el-table-column>
            <el-table-column label="操作" fixed="right" width="200">
                <template slot-scope="scope">
                    <el-tooltip content="重试"
                                v-if="[4,9,11].includes(scope.row.txStatus) && scope.row.txStatusInner !== 'RE_CHECK'">
                        <el-button size="small" circle icon="el-icon-refresh"
                                   @click="retryWithdrawal(scope.row)"></el-button>
                    </el-tooltip>
                    <el-tooltip content="重置" v-if="scope.row.txStatus === -1">
                        <el-button type="success" @click="reset(scope.row)" icon="el-icon-refresh" size="small"
                                   circle></el-button>
                    </el-tooltip>
                    <el-tooltip content="审核通过" v-if="scope.row.txStatus === 1">
                        <el-button type="success" @click="approveAudit(scope.row)" icon="el-icon-success" size="small"
                                   circle></el-button>
                    </el-tooltip>
                    <el-tooltip content="置为异常"
                                v-if="[1,4,9,11].includes(scope.row.txStatus) && scope.row.txStatusInner !== 'RE_CHECK'">
                        <el-button type="danger" @click="freezeAudit(scope.row)" size="small" icon="el-icon-warning"
                                   circle></el-button>
                    </el-tooltip>
                    <el-tooltip content="撤销" v-if="(scope.row.txStatus === 1)||(scope.row.txStatus === 6)">
                        <el-button @click="cancelAuditDialog(scope.row)" size="small" circle
                                   icon="el-icon-back"></el-button>
                    </el-tooltip>
                    <el-tooltip content="审核为手动提现" v-if="scope.row.txStatus === 1">
                        <el-button type="warning" @click="approveToHand(scope.row)" icon="el-icon-star-off" size="small"
                                   circle></el-button>
                    </el-tooltip>
                    <el-tooltip content="发起提现"
                                v-if="scope.row.txStatus === 4 && scope.row.txStatusInner !== 'RE_CHECK'">
                        <el-button @click="showSendDialog(scope.row.id)" size="small" type="success"
                                   icon="el-icon-check" circle></el-button>
                    </el-tooltip>
                    <el-tooltip content="撤回" v-if="scope.row.txStatus === 4">
                        <el-button @click="cancelTwoAuditDialog(scope.row)" size="small" type="danger"
                                   icon="el-icon-back" circle></el-button>
                    </el-tooltip>
                    <el-tooltip content="手动转账确认成功" v-if="scope.row.txStatus === 5">
                        <el-button type="success" @click="handleManualConfirm(scope.row.id)" icon="el-icon-success"
                                   size="small" circle></el-button>
                    </el-tooltip>
                    <el-tooltip content="退回未审核" v-if="scope.row.txStatus === 5 && userInfo.roleId === 1">
                        <el-button @click="handleReturnToNotApproved(scope.row.id)" icon="el-icon-back" size="small"
                                   circle></el-button>
                    </el-tooltip>
                    <el-tooltip content="二次提现审核"
                                v-if="rightsContains('RE_APPROVE_WITHDRAW') && scope.row.txStatusInner === 'RE_CHECK'">
                        <el-button @click="reApproveWithdraw(scope.row.id)" icon="el-icon-star-off" circle
                                   type="warning"></el-button>
                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>
        <div class="pager-wrap" style="text-align:right;margin:10px 0px;">
            <pagination :size="pagination.size" :page="pagination.page" :total="audistCount"
                        @pageChanged="handleCurrentChange"></pagination>
        </div>
        <div class="user-withdrawal-records-wrap">
            <el-dialog :visible.sync="showUserDialog" title="账户余额信息" width="1200px">
                <withdraw-records v-if="showUserDialog" :uid="nowUserId"></withdraw-records>
            </el-dialog>
        </div>
        <div class="send-trans-dialog">
            <el-dialog :visible.sync="ifShowSendDialog" @close="closeSendDialog" width="800px">
                <el-form :model="sendTransForm" ref="sendTransForm" label-width="100px">
                    <el-form-item prop="transId" label="网络ID" :rules="[{required: true, message: '请输入网路ID'}]">
                        <el-input v-model="sendTransForm.transId"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="sendTransNow()">确定提交</el-button>
                        <el-button @click="closeSendDialog()">取消</el-button>
                    </el-form-item>
                </el-form>
            </el-dialog>
        </div>

        <el-dialog title="提示" :visible.sync="cancelAuditVisible" width="800px" @close="clearData">
            <el-form>
                <el-form-item label="确认要撤销吗？" label-width="150px">
                </el-form-item>
                <el-form-item label="原因(中文)" label-width="120px">
                    <el-input type="textarea" maxlength="100" show-word-limit="true" v-model="cancelData.zh"></el-input>
                </el-form-item>
                <el-form-item label="原因(英文)" label-width="120px">
                    <el-input type="textarea" maxlength="100" show-word-limit="true" v-model="cancelData.en"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="clearData">取 消</el-button>
                <el-button type="primary" @click="cancelAudit">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {mapState, mapActions} from 'vuex';
    import WithdrawRecords from '../records';
    import Pagination from 'components/pagination';
    import {RIGHTS_TYPE} from "../../../../../common/constant";
    import api from '../../api';

    export default {
        name: 'AuditList',
        data() {
            return {
                showUserDialog: false,
                ifShowSendDialog: false,
                cancelAuditVisible: false,
                nowUserId: '',
                sendOrderId: '',
                sendTransForm: {
                    id: ''
                },
                cancelDataParams: {id: "", failReason: ""},
                cancelData: {remark: "", tag: "", zh: "", en: ""},
                retryableStatus: [
                    'FAIL_CANNOT_RETRY',
                    'EXECUTING_WITHDRAW',
                    'HOT_NOT_ENOUGH_MONEY',
                    'DUPLICATE_TO_ADDRESS'
                ],
                multipleSelection: []
            };
        },
        computed: {
            ...mapState('withdrawalAudit', [
                'auditList',
                'allCoins',
                'audistCount',
                'pagination',
                'showTag',
                'activeTab'
            ]),
            ...mapState(['userInfo', 'userRights'])
        },
        filters: {
            toThousands(num) {
                let result = '', counter = 0;
                num = (num || 0).toString();
                let n1 = num.split(".");
                if (n1.length == 0) {
                    return result;
                }
                for (var i = n1[0].length - 1; i >= 0; i--) {
                    counter++;
                    result = n1[0].charAt(i) + result;
                    if (!(counter % 3) && i != 0) {
                        result = ',' + result;
                    }
                }

                if (n1.length == 2) {
                    return result +"."+ n1[1];
                }
                return result;
            }
        },
        methods: {
            ...mapActions('withdrawalAudit', [
                'approve',
                'approveHand',
                'retry',
                'resetUserRecords',
                'setAuditToErr',
                'cancel',
                'updateFreeze',
                'sendWithdrawalTrans',
                'remark',
                'manualConfirm',
                'returnToNotApproved',
                'cancelTwoWithdraw','getRebateAmount'
            ]),
            filterHandler(value, row, column) {
                const property = column['property'];
                return row[property] === value;
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            batchAuditPass() {
                if (this.multipleSelection.length <= 0) {
                    this.$message.info("请勾选需要审核的数据");
                    return;
                }
                this.$confirm('确认进行批量审核吗', '提示', {
                    type: 'warning'
                }).then(() => {
                    for (let i = 0; i < this.multipleSelection.length; i++) {
                        this.approve(this.multipleSelection[i].id);
                    }
                    this.refreshList();
                }).catch(() => {
                });
            },
            showPrompt(content, audit, callback) {
                return this.$prompt(content, '提示', {
                    inputPlaceholder: '备注信息',
                    inputValue: audit.remark
                }).then(({value}) => {
                    return callback(value)
                        .then(() => {
                            return value !== audit.remark
                                ? this.remark({id: audit.id, remark: value})
                                : Promise.resolve(); //如果值未修改则不请求
                        })
                        .then(() => {
                            this.$message({
                                message: '操作成功！',
                                type: 'success'
                            });
                            this.refreshList();
                        });
                });
            },
            reset(audit){
                this.$confirm('确认重置吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                    }).then(() => {
                        api.reset({id:audit.id}).then(res=>{
                            this.refreshList();
                            this.$message({
                                type: 'success',
                                message: '重置成功!'
                            });       
                        })
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消重置'
                        });          
                });
            },
            approveAudit(audit) {
                if (audit.tags === null || audit.tags.length === 0) {
                       this.showPrompt('确认通过审核吗？', audit, () => this.approve(audit.id));
                    if(audit.riskFlag == true){
                        this.$confirm('该用户处在风控状态，请确认后，再审批提现订单！', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(()=>{
                            this.showPrompt('确认通过审核吗？', audit, () =>  this.approve(audit.id));
                        }).catch(()=>{
                            this.$message.info("已取消执行")
                        })
                        
                    }else{
                        this.showPrompt('确认通过审核吗？', audit, () => this.approve(audit.id));
                    } 
                } else {
                    this.$confirm("该用户为：" + audit.tags + "，是否继续?", "提示", {
                        confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
                    }).then(() => {
                        this.showPrompt('确认通过审核吗？', audit, () => this.approve(audit.id));
                    })
                        .catch(() => {
                            this.$message.info("已取消执行")
                        })
                }
            },
            approveToHand(audit) {
                if (audit.tags === null || audit.tags.length === 0) {
                    this.showPrompt('确认审核为手动提现吗？', audit, () => this.approveHand(audit.id));
                } else {
                    this.$confirm("该用户为：" + audit.tags + "，是否继续?", "提示", {
                        confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
                    }).then(() => {
                        this.showPrompt('确认审核为手动提现吗？', audit, () => this.approveHand(audit.id));
                    })
                        .catch(() => {
                            this.$message.info("已取消执行")
                        })
                }
            },
            freezeAudit(audit) {
                if (audit.tags === null || audit.tags.length === 0) {
                    this.showPrompt('确认要置为异常吗？', audit, () => this.updateFreeze(audit.id));
                } else {
                    this.$confirm("该用户为：" + audit.tags + "，是否继续?", "提示", {
                        confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
                    }).then(() => {
                        this.showPrompt('确认要置为异常吗？', audit, () => this.updateFreeze(audit.id));
                    }).catch(() => {
                        this.$message.info("已取消执行")
                    })
                }
            },
            cancelAuditDialog(audit) {
                this.cancelDataParams.id = audit.id;
                this.cancelData.tags = audit.tags;
                this.cancelAuditVisible = true;
            },
            cancelTwoAuditDialog(audit) {
                if (audit.tags === null || audit.tags.length === 0) {
                    this.showPrompt('确认要撤回吗？', audit, () => this.cancelTwoWithdraw({id: audit.id}));
                } else {
                    this.$confirm("该用户为：" + audit.tags + "，是否继续?", "提示", {
                        confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
                    }).then(() => {
                        this.showPrompt('确认要撤回吗？', audit, () => this.cancelTwoWithdraw({id: audit.id}));
                    }).catch(() => {
                        this.$message.info("已取消执行")
                    })
                }
            },
            cancelAudit() {
                this.cancelDataParams.failReason = JSON.stringify({zh: this.cancelData.zh, en: this.cancelData.en});
                if (this.cancelData.tags === null || this.cancelData.tags.length === 0) {
                    this.cancelAuditApi(this.cancelDataParams);
                } else {
                    this.$confirm("该用户为：" + this.cancelData.tags + "，是否继续?", "提示", {
                        confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
                    }).then(({value}) => {
                        this.cancelAuditApi(this.cancelDataParams);
                    }).catch(() => {
                        this.$message.info("已取消执行")
                    })
                }
            },
            cancelAuditApi(param) {
                api.cancel(param).then(() => {
                    this.$message.success('操作成功');
                    if (this.cancelData.remark !== this.cancelData.zh) {
                        this.remark({id: param.id, remark: this.cancelData.zh})
                    }
                    this.cancelAuditVisible = false;
                    this.refreshList();
                })
            },
            clearData() {
                this.cancelAuditVisible = false;
                this.cancelDataParams = {id: "", failReason: ""};
                this.cancelData = {remark: "", tag: "", zh: "", en: ""};
            },
            retryWithdrawal(audit) {
                if (audit.tags === null || audit.tags.length === 0) {
                    this.showPrompt('重试前，请确认该提现地址在区块链浏览器上没有此平台的转账记录。', audit, () => this.retry(audit.id));
                } else {
                    this.$confirm("该用户为：" + audit.tags + "，是否继续?", "提示", {
                        confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
                    }).then(() => {
                        this.showPrompt('重试前，请确认该提现地址在区块链浏览器上没有此平台的转账记录。', audit, () => this.retry(audit.id));
                    })
                        .catch(() => {
                            this.$message.info("已取消执行")
                        })
                }
            },
            setAuditError(audit) {
                if (audit.tags === null || audit.tags.length === 0) {
                    this.showPrompt('确认将该记录置为异常？', audit, () => this.setAuditToErr(audit.id));
                } else {
                    this.$confirm("该用户为：" + audit.tags + "，是否继续?", "提示", {
                        confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
                    }).then(() => {
                        this.showPrompt('确认将该记录置为异常？', audit, () => this.setAuditToErr(audit.id));
                    })
                        .catch(() => {
                            this.$message.info("已取消执行")
                        })
                }
            },
            getUserDetail(uid) {
                this.nowUserId = uid;
                // this.getRebateAmount({ userId: uid })
                    this.showUserDialog = true;
                
            },
            refreshList() {
                this.handleCurrentChange({
                    page: 1
                });
            },
            handleCurrentChange(pagination) {
                this.$emit('refresh', pagination);
            },
            showSendDialog(id) {
                this.sendOrderId = id;
                this.ifShowSendDialog = true;
            },
            sendTransNow() {
                this.$refs['sendTransForm'].validate(valid => {
                    if (valid) {
                        this.sendWithdrawalTrans({
                            id: this.sendOrderId,
                            transId: this.sendTransForm.transId
                        }).then(() => {
                            this.closeSendDialog();
                            this.$message({
                                message: '操作成功！',
                                type: 'success'
                            });
                            this.refreshList();
                        });
                    }
                });
            },
            closeSendDialog() {
                this.$refs['sendTransForm'] && this.$refs['sendTransForm'].resetFields();
                this.ifShowSendDialog = false;
            },
            handleManualConfirm(txId) {
                this.$confirm('确认手动转账已成功吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    this.manualConfirm(txId).then(() => {
                        this.$message.success('操作成功！');
                        this.refreshList();
                    });
                });
            },
            handleReturnToNotApproved(txId) {
                this.$confirm('确认退回未审核状态吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    this.returnToNotApproved(txId).then(() => {
                        this.$message.success('操作成功！');
                        this.refreshList();
                    });
                });
            },
            rightsContains(r) {
                let rights = this.userRights.split(",") || [];
                return rights.indexOf(RIGHTS_TYPE[r]) !== -1;
            },
            reApproveWithdraw(id) {
                this.$confirm('提现二次审核确认', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.reApproveAudit(id).then(() => {
                        this.$message.success('操作成功');
                        this.refreshList();
                    })
                })
            },
    getcopy(userid){
        let oInput = document.createElement('input'); 
        oInput.value = userid;    //赋值
        document.body.appendChild(oInput);
        oInput.select(); 
        document.execCommand("Copy"); 
        oInput.className = 'oInput';
        oInput.style.display = 'none';
        this.$message.success('复制成功');
    }
        },
        components: {
            WithdrawRecords,
            Pagination
        }
    };
</script>

<style lang="less" scoped>
    @import url('~styles/variables.less');

    .account-link,
    .network-link {
        color: @color-primary;

        &:hover {
            text-decoration: underline;
        }
    }

    .el-button {
        margin: 10px 10px 0px 0px;
    }
    .copystyle{
        display: flex;
        align-items: center;
        img{
            cursor:pointer;
        }
    }
</style>
